import { useEffect } from "react";
import useMobileDetection from "./useMobileDetection";

const usePreventRefresh = ({ onlyMobile = true }: { onlyMobile?: boolean }) => {
  const isMobile = useMobileDetection();

  const shouldPrevent = isMobile || !onlyMobile;

  useEffect(() => {
    if (!shouldPrevent) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "Halaman page akan dimuat kembali"; // This triggers the confirmation prompt
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [shouldPrevent]);
};

export default usePreventRefresh;
